// 获取机考辅导id
const majorTag = 'seco';
const settings = {
  //项目名称
  title: '高级经济师电子化模拟系统',
  //机考辅导类型
  category: '高级经济师',
  //机考辅导ID  初级80 中级12 高级30
  majorID: 30,
  // 辅导唯一标识
  majorTag: majorTag,
  //生产环境二级路径
  publicPath: '/qzSim/' + majorTag + '/',
  //生产环境构建文件目录
  outputDir: 'webApp',
  //静态资源放置目录
  assetsDir: 'static',
  //aes密钥
  aesKey: '823s4125660ijf;*',
  //iv密钥
  ivKey: 'qyu148#4(1p_1^4;',
  //请求接口地址
  baseApi: '/simPaperGw/moniexam',
  //请求重试delay
  retryDelay: 5000
};
module.exports = settings;
